const sizes = [300, 600, 1200, 1800]
const outputDir = '/images/uploads/'

const netlifyResizeQuery = size => `?nf_resize=fit&w=${size}`

const getImageSrcset = path => {
  if (path.indexOf('http') >= 0) {
    return console.warn('Cannot get srcset for external image: ' + path)
  }

  const srcset = sizes
    .map(size => `${encodeURI(path + netlifyResizeQuery(size))} ${size}w`)
    .join(', ')
  return srcset
}

const getImageSrc = (path, sizeRequested) => {
  if (path.indexOf('http') >= 0) return path
  sizeRequested = parseInt(sizeRequested, 10)
  let size
  if (sizeRequested) {
    // rounds up to nearest size or returns largest
    size =
      sizes.filter(num => num >= sizeRequested)[0] || sizes[sizes.length - 1]
  } else {
    // get the middle size
    size = sizes[Math.ceil(sizes.length / 2)]
  }

  return encodeURI(path + netlifyResizeQuery(size))
}

module.exports = {
  getImageSrcset,
  getImageSrc,
  sizes,
  outputDir
}



// WEBPACK FOOTER //
// ./src/util/getImageUrl.js